import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ServicesHeroBanner from "../components/ServicesHeroBanner";
import MultpleCard from "../components/Multple-card";
import ServicesProcess from "../components/ServicesProcess";
import Choose from "../components/Choose";
import ContactForm from "../components/contact-form";
import Blog from "../components/Blog";

import servicesHeaderImage from "../images/comp/services-header-image-8.webp";
import diverseImage from "../images/comp/choose_development_img.webp";
import researchIcon from "../images/research-icon.png";
import planningIcon from "../images/Planning.png";
import designIcon from "../images/Design.png";
import ux_icon from "../images/ux_icon.png";
import supportIcon from "../images/Support.png";
import developmentIcon from "../images/development.png";
import qualityIcon from "../images/Quality.png";
import testingIcon from "../images/Testing.png";

const DevelopmentsupportPage = () => {
  const heroBannerData = {
    subtitle: "Development Support",
    title: "Support That’s Reliable. Development That Scales.",
    description:
      "At Hope Web Solutions, we provide dedicated development support to help businesses maintain, scale, and enhance their digital platforms. Whether it's fixing bugs, adding new features, or ensuring performance and security—we’re your reliable tech partner for ongoing website and application support.",
    buttonText: "Contact now",
    buttonLink: "#contact",
    img: servicesHeaderImage,
  };
  const cardsData = [
    {
      title: "Ongoing Website Maintenance",
      description:
        "Regular updates, security patches, and performance improvements to keep your website running smoothly.",
      icon: researchIcon,
    },
    {
      title: "Performance Optimization",
      description:
        "Analyzing and optimizing your website's load times, code efficiency, and user experience for faster performance and better engagement.",
      icon: planningIcon,
    },
    {
      title: "Feature Enhancements",
      description:
        "Adding new functionality, sections, or integrations based on your evolving business needs.",
      icon: designIcon,
    },
    {
      title: "Security Monitoring & Fixes",
      description:
        "Continuous monitoring of vulnerabilities, malware threats, and system errors to keep your site secure and compliant.",
      icon: developmentIcon,
    },
    {
      title: "CMS & Plugin Updates",
      description:
        "Keeping your WordPress, Joomla, or custom CMS and all plugins/modules updated and compatible.",
      icon: testingIcon,
    },
    {
      title: "Third-Party Integrations",
      description:
        "Connecting Zoho apps with platforms like Shopify, WordPress, WhatsApp, and more for streamlined operations.",
      icon: qualityIcon,
    },
  ];

  const processData = [
    {
      title: "Requirement Analysis",
      description:
        "Understanding your current system, issues, and goals to plan the right support strategy.",
      icon: researchIcon,
    },
    {
      title: "Task Prioritization",
      description:
        "Listing bugs, enhancements, or integrations based on urgency and business impact.",
      icon: designIcon,
    },
    {
      title: "Development & Fixes",
      description:
        "Resolving technical issues, updating code, and implementing security patches.",
      icon: ux_icon,
    },
    {
      title: "Testing & Validation",
      description:
        "Testing on multiple devices and environments to ensure stability and performance.",
      icon: developmentIcon,
    },
    {
      title: "Deployment",
      description:
        "Deploying updates and ensuring smooth transition with minimal downtime.",
      icon: testingIcon,
    },
    {
      title: "Ongoing Monitoring & Reporting",
      description:
        "Continuous monitoring of system performance, security, and user feedback.",
      icon: supportIcon,
    },
  ];

  const chooseData = {
    title: "Why Choose Hope Web Solutions?",
    image: diverseImage,
    imageAlt: "Team",
    items: [
      {
        label: "Planning",
        text: "Hope Web Solutions is a leading Web and Mobile App Development company, delivering cutting-edge digital solutions.",
      },
      {
        label: "Our Mission",
        text: "Our mission is to empower businesses with exceptional digital solutions that drive growth, enhance user experience.",
      },
      {
        label: "Our Vision",
        text: "Our vision is to be a global leader in web and mobile app development, recognized for our innovation, quality, and customer satisfaction.",
      },
    ],
    buttonText: "Contact now",
    buttonLink: "/contact",
  };
  return (
    <div>
      <Header />
      <ServicesHeroBanner {...heroBannerData} />
      <section className="planning-section-services">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-8 mb-4 mb-lg-0 position-relative text-center">
              <h2 className="title">Development Support Services</h2>
              <p className="sub-title text-black pt-2">
                We offer flexible and scalable development support services
                tailored to your project needs and timelines.
              </p>
            </div>
          </div>
          <div className="process-grid mt-3">
            {/* 👉 Cards Loop */}
            {cardsData.map((item, index) => (
              <MultpleCard
                key={index}
                title={item.title}
                description={item.description}
                icon={item.icon}
              />
            ))}
          </div>
        </div>
      </section>
      <ServicesProcess
        title="Development Support Process"
        subtitle="Our streamlined process ensures your development support is reliable, efficient, and aligned with your business objectives."
        processData={processData}
      />
      <Choose {...chooseData} />
      <ContactForm />
      <Blog />
      <Footer />
    </div>
  );
};

export default DevelopmentsupportPage;
